/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Zesty_Shy_Polecat_LearnInputs */

const fr_zesty_shy_polecat_learn = /** @type {(inputs: Zesty_Shy_Polecat_LearnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisis un produit et un prix pour ton programme.`)
};

/**

* @param {Zesty_Shy_Polecat_LearnInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const zesty_shy_polecat_learn = /** @type {((inputs?: Zesty_Shy_Polecat_LearnInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Zesty_Shy_Polecat_LearnInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_zesty_shy_polecat_learn(inputs)
});